import { Button } from 'components/Button';
import { cx } from '@linaria/core';
import { format } from 'date-fns';
import { TextIcon } from 'components/TextIcon';
import { makeInitials, stringToColor } from 'utils/strings/strings';
import { avatar } from 'components/Navbar/components/Account/styles';
import { basicTemplateWrapper } from './template.styles';
import { NotificationState } from '../interface';

export const NotificationTemplate: React.FC<NotificationState> = ({
  acceptBtn = { text: 'Accept', onClick: () => {} },
  declineBtn = { text: 'Decline', onClick: () => {} },
  header,
  body,
  title,
  className,
  closeButton,
  isLoading,
  hideIcon,
  createdDate,
  type = 'info',
  ...props
}) => {
  return (
    <div className={cx(basicTemplateWrapper, className)} {...props} data-notification-type={type}>
      <div className="title">
        {!hideIcon && <TextIcon text={makeInitials(title ?? '')} background={stringToColor(title ?? '')} className={cx('avatar', avatar)} />}

        <h3 className={type}>{header}</h3>
        {closeButton}
      </div>
      <p>{body}</p>
      {createdDate && <p>{format(new Date(createdDate), 'EEE d LLL H:mm')}h.</p>}

      <div className="button-group">
        {acceptBtn ? (
          <Button
            data-testid="org-invite-accept-btn"
            variant={type === 'error' ? 'danger' : 'primary'}
            size="sm"
            disabled={isLoading}
            loading={isLoading}
            onClick={acceptBtn.onClick}
          >
            {acceptBtn.text}
          </Button>
        ) : null}
        {declineBtn ? (
          <Button
            data-testid="org-invite-decline-btn"
            variant="tertiary"
            size="sm"
            disabled={isLoading}
            loading={isLoading}
            onClick={declineBtn.onClick}
          >
            {declineBtn.text}
          </Button>
        ) : null}
      </div>
    </div>
  );
};
